function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LatLng } from 'leaflet';
var TABLE = 'venue';
var COLUMNS = ['id', 'name', 'district', 'city', 'state', 'latitude', 'longitude', 'data'];

var Venue = /*#__PURE__*/function () {
  _createClass(Venue, null, [{
    key: "all",
    value: function all(storage) {
      return storage.stageVenuesPromise.then(function () {
        return storage.all('venue').then(function (resultSet) {
          return resultSet.map(function (v) {
            return new Venue(v);
          });
        });
      });
    }
  }]);

  function Venue(props) {
    var _this = this;

    _classCallCheck(this, Venue);

    _defineProperty(this, "save", function (storage) {
      return storage.addOrUpdate(Venue.TABLE, _this.id, COLUMNS.slice(1, COLUMNS.length), [_this.name, _this.district, _this.city, _this.state, _this.latitude, _this.longitude, JSON.stringify(_this)]);
    });

    _extends(this, props);

    this.position = new LatLng(props.latitude, props.longitude);
  }

  return Venue;
}();

Venue.TABLE = TABLE;
Venue.COLUMNS = COLUMNS;
export default Venue;